<template>

  <motion.div class="agenda-page">

    <motion.div class="modern-header">

      <motion.div class="header-container">

        <motion.div class="breadcrumb-section">

          <nav class="breadcrumb">

            <button type="button" class="breadcrumb-item" @click="router.push('/dashboard')">

              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">

                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>

              </svg>

              {{ t('common.breadcrumb.dashboard') }}

            </button>

            <span class="breadcrumb-separator">/</span>

            <button type="button" class="breadcrumb-item" @click="router.push(`/workspace/${workspaceId}`)">

              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">

                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>

              </svg>

              {{ currentWorkspace?.nome || workspaceNome }}

            </button>

            <span class="breadcrumb-separator">/</span>

            <span class="breadcrumb-current">{{ t('workspaceAgenda.breadcrumbCurrent') }}</span>

          </nav>

        </motion.div>



        <motion.div class="title-section">

          <motion.div class="title-content">

            <motion.div class="title-icon title-icon--agenda">

              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">

                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>

              </svg>

            </motion.div>

            <motion.div class="title-text">

              <h1 class="main-title">{{ t('workspaceAgenda.title') }}</h1>

              <p class="subtitle">{{ subtituloPagina }}</p>

            </motion.div>

          </motion.div>

          <motion.div

            class="workspace-badge"

            :class="`type-${(currentWorkspace?.tipo || 'TAREFAS').toLowerCase()}`"

          >

            <motion.div class="badge-icon">

              <svg v-if="currentWorkspace?.tipo === 'CRM'" class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">

                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>

              </svg>

              <svg v-else class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">

                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01"/>

              </svg>

            </motion.div>

            <span class="badge-text">{{ currentWorkspace?.tipo || 'TAREFAS' }}</span>

          </motion.div>

        </motion.div>



        <motion.div class="actions-section">

          <motion.div class="actions-left">

            <motion.div class="month-nav" role="group" :aria-label="t('workspaceAgenda.monthNav')">

              <button type="button" class="month-nav-btn" :aria-label="t('workspaceAgenda.prevMonth')" @click="mesAnterior">

                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">

                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7"/>

                </svg>

              </button>

              <span class="month-nav-label">{{ tituloMes }}</span>

              <button type="button" class="month-nav-btn" :aria-label="t('workspaceAgenda.nextMonth')" @click="mesProximo">

                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">

                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>

                </svg>

              </button>

            </motion.div>

            <button type="button" class="action-button secondary" @click="irParaHoje">{{ t('workspaceAgenda.today') }}</button>

          </motion.div>

          <motion.div class="actions-right">

            <button

              type="button"

              class="action-button primary"

              @click="router.push(`/workspace/${workspaceId}/dashboard`)"

            >

              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">

                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 19l-7-7m0 0l7-7m-7 7h18"/>

              </svg>

              {{ t('workspaceAgenda.back') }}

            </button>

          </motion.div>

        </motion.div>

      </motion.div>

    </motion.div>



    <motion.div class="page-content">

      <motion.div class="layout">

        <section class="card cal">

          <div class="weekdays">

            <span v-for="d in weekLabels" :key="d">{{ d }}</span>

          </div>

          <div class="days">

            <button
              v-for="cell in calendarCells"
              :key="cell.key"
              type="button"
              class="day"
              :class="{
                muted: !cell.inMonth,
                selected: cell.iso === selectedIso,
                hoje: cell.iso === hojeIso,
                'day--has': cell.hasSchedules && cell.inMonth,
                'day--past': cell.iso < hojeIso
              }"
              @click="selecionar(cell.iso)"
            >
              <span class="day-num">{{ cell.day }}</span>
              <span
                v-if="cell.hasSchedules && cell.inMonth"
                class="day-badge"
                :title="t('workspaceAgenda.scheduleCount', { count: cell.scheduleCount })"
              >{{ cell.scheduleCount }}</span>
            </button>

          </div>

        </section>



        <section class="card lista">

          <div class="lista-head">
            <h2 class="lista-title">{{ dataLegivel }}</h2>
            <span v-if="!loading && !erro" class="lista-count">
              {{ itens.length }} {{ itens.length === 1 ? t('workspaceAgenda.appointmentsOne') : t('workspaceAgenda.appointmentsMany') }}
            </span>
          </div>

          <div v-if="isServicos" class="agenda-legend" role="list" :aria-label="t('workspaceAgenda.legendTitle')">
            <span v-for="leg in statusLegend" :key="leg.key" class="agenda-legend__item" role="listitem">
              <span class="agenda-legend__dot" :class="`agenda-legend__dot--${leg.key}`" />
              {{ leg.label }}
            </span>
          </div>

          <div v-if="loading" class="lista-state">
            <span class="lista-state-spinner" aria-hidden="true" />
            <p>{{ t('workspaceAgenda.loading') }}</p>
          </div>
          <p v-else-if="erro" class="erro">{{ erro }}</p>

          <ul v-else class="itens">
            <li
              v-for="it in itens"
              :key="`${it.tipo}-${it.agendamentoId}`"
              class="agenda-item"
              :class="itemClasse(it)"
              @click="abrir(it)"
            >
              <div class="agenda-item-time" :aria-label="t('workspaceAgenda.timeAria')">
                <span class="agenda-item-hour">{{ horarioExibicao(it.horario) }}</span>
              </div>
              <div class="agenda-item-accent" aria-hidden="true" />
              <div class="agenda-item-body">
                <div class="agenda-item-top">
                  <span class="agenda-item-type">
                    <svg v-if="it.tipo === 'TASK'" class="agenda-item-type-ico" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5H7a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"/>
                    </svg>
                    <svg v-else-if="it.tipo === 'CLIENTE'" class="agenda-item-type-ico" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                    </svg>
                    <svg v-else class="agenda-item-type-ico" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                    </svg>
                    {{ itemTipoLabel(it) }}
                  </span>
                  <span v-if="isServicos && it.status" class="agenda-item-status" :class="`agenda-item-status--${statusClasse(it.status)}`">
                    {{ statusLabel(it.status) }}
                  </span>
                  <span v-else-if="it.colunaNome" class="agenda-item-col">{{ it.colunaNome }}</span>
                </div>
                <h3 class="agenda-item-title">{{ it.titulo }}</h3>
                <p v-if="it.motivo" class="agenda-item-motivo">
                  <svg class="agenda-item-motivo-ico" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 8h10M7 12h4m1 8l-4-4H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-3l-4 4z"/>
                  </svg>
                  {{ it.motivo }}
                </p>
              </div>
              <svg class="agenda-item-arrow" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"/>
              </svg>
            </li>

            <li v-if="!itens.length" class="agenda-empty">
              <div class="agenda-empty-icon" aria-hidden="true">
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/>
                </svg>
              </div>
              <p class="agenda-empty-title">{{ t('workspaceAgenda.emptyTitle') }}</p>
              <p class="agenda-empty-text">{{ t('workspaceAgenda.emptyText') }}</p>
            </li>
          </ul>

        </section>

      </motion.div>

    </motion.div>



    <LeadDetailModal

      v-if="workspaceStore.currentWorkspace?.tipo === 'CRM'"

      :is-open="showLead"

      :lead="selectedLead"

      @close="showLead = false"

      @lead-updated="onLeadPatch"

    />

    <TaskDetailModal

      v-if="workspaceStore.currentWorkspace?.tipo === 'TAREFAS'"

      :is-open="showTask"

      :task="selectedTask"

      @close="showTask = false"

      @taskUpdated="onTaskPatch"

    />

  </motion.div>

</template>



<script setup>

import { ref, computed, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'

import { useRoute, useRouter } from 'vue-router'

import { motion } from 'motion-v'

import { useWorkspaceStore } from '../stores/workspace'

import api from '../services/api'

import LeadDetailModal from '../components/LeadDetailModal.vue'

import TaskDetailModal from '../components/TaskDetailModal.vue'



const { t, locale, tm } = useI18n()

const route = useRoute()

const router = useRouter()

const workspaceStore = useWorkspaceStore()



const workspaceId = computed(() => Number(route.params.id))

const workspaceNome = computed(() => workspaceStore.currentWorkspace?.nome || t('workspaceDashboard.defaultName'))

const currentWorkspace = computed(() => workspaceStore.currentWorkspace)

const isServicos = computed(() => currentWorkspace.value?.tipo === 'SERVICOS')

const subtituloPagina = computed(() => {
  if (currentWorkspace.value?.tipo === 'CRM') {
    return t('workspaceAgenda.subtitleCrm')
  }
  if (isServicos.value) {
    return t('workspaceAgenda.subtitleServicos')
  }
  return t('workspaceAgenda.subtitleTasks')
})

const statusLegend = computed(() => [
  { key: 'agendado', label: t('workspaceAgenda.statusAgendado') },
  { key: 'realizado', label: t('workspaceAgenda.statusRealizado') },
  { key: 'remarcado', label: t('workspaceAgenda.statusRemarcado') },
  { key: 'cancelado', label: t('workspaceAgenda.statusCancelado') }
])

const dateLocale = computed(() => {
  if (locale.value === 'en') return 'en-US'
  if (locale.value === 'es') return 'es'
  return 'pt-BR'
})



const viewYear = ref(new Date().getFullYear())

const viewMonth = ref(new Date().getMonth() + 1)

const selectedIso = ref(toIsoDate(new Date()))



const loading = ref(false)

const erro = ref('')

const itens = ref([])
const mesContagens = ref({})


const showLead = ref(false)

const showTask = ref(false)

const selectedLead = ref(null)

const selectedTask = ref(null)



const weekLabels = computed(() => tm('workspaceAgenda.weekdays'))



function pad(n) {

  return String(n).padStart(2, '0')

}



function toIsoDate(d) {

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`

}



const hojeIso = computed(() => toIsoDate(new Date()))



const tituloMes = computed(() => {

  const d = new Date(viewYear.value, viewMonth.value - 1, 1)

  return d.toLocaleDateString(dateLocale.value, { month: 'long', year: 'numeric' })

})



const dataLegivel = computed(() => {

  const [y, m, d] = selectedIso.value.split('-').map(Number)

  const dt = new Date(y, m - 1, d)

  return dt.toLocaleDateString(dateLocale.value, { weekday: 'long', day: '2-digit', month: 'long', year: 'numeric' })

})

function tipoClasse(tipo) {
  return tipo === 'LEAD' ? 'lead' : 'task'
}

function statusClasse(status) {
  const s = String(status || 'AGENDADO').trim().toUpperCase()
  const map = {
    AGENDADO: 'agendado',
    REALIZADO: 'realizado',
    REMARCADO: 'remarcado',
    CANCELADO: 'cancelado'
  }
  return map[s] || 'agendado'
}

function statusLabel(status) {
  const key = statusClasse(status)
  return t(`workspaceAgenda.status${key.charAt(0).toUpperCase()}${key.slice(1)}`)
}

function itemClasse(it) {
  if (isServicos.value && it.tipo === 'CLIENTE') {
    return `agenda-item--${statusClasse(it.status)}`
  }
  return `agenda-item--${tipoClasse(it.tipo)}`
}

function itemTipoLabel(it) {
  if (it.tipo === 'TASK') return t('workspaceAgenda.typeTask')
  if (it.tipo === 'CLIENTE') return t('workspaceAgenda.typeCliente')
  return t('workspaceAgenda.typeLead')
}

function horarioExibicao(horario) {
  if (!horario) return '—'
  const m = String(horario).match(/^(\d{1,2}):(\d{2})/)
  if (m) return `${m[1].padStart(2, '0')}:${m[2]}`
  return horario
}



const calendarCells = computed(() => {

  const first = new Date(viewYear.value, viewMonth.value - 1, 1)

  const startWeekday = first.getDay()

  const daysInMonth = new Date(viewYear.value, viewMonth.value, 0).getDate()

  const prevMonthDays = new Date(viewYear.value, viewMonth.value - 1, 0).getDate()



  const cells = []

  for (let i = 0; i < startWeekday; i++) {

    const day = prevMonthDays - startWeekday + i + 1

    const prev = new Date(viewYear.value, viewMonth.value - 2, day)

    cells.push({

      key: `p-${prev.getFullYear()}-${prev.getMonth() + 1}-${day}`,

      day,

      iso: toIsoDate(prev),
      inMonth: false

    })

  }

  for (let d = 1; d <= daysInMonth; d++) {

    const cur = new Date(viewYear.value, viewMonth.value - 1, d)

    cells.push({

      key: `c-${viewYear.value}-${viewMonth.value}-${d}`,

      day: d,

      iso: toIsoDate(cur),

      inMonth: true

    })

  }

  while (cells.length % 7 !== 0) {

    const last = cells[cells.length - 1]

    const [y, m, da] = last.iso.split('-').map(Number)

    const next = new Date(y, m - 1, da + 1)

    cells.push({

      key: `n-${next.getFullYear()}-${next.getMonth() + 1}-${next.getDate()}`,

      day: next.getDate(),

      iso: toIsoDate(next),

      inMonth: false

    })

  }

  return cells.map((cell) => {
    const qtd = mesContagens.value[cell.iso] || 0
    return {
      ...cell,
      scheduleCount: qtd,
      hasSchedules: qtd > 0
    }
  })

})




function gridRangeFromCells(cells) {
  if (!cells.length) return { from: selectedIso.value, to: selectedIso.value }
  return { from: cells[0].iso, to: cells[cells.length - 1].iso }
}

const carregarContagensMes = async () => {
  const baseCells = []
  const first = new Date(viewYear.value, viewMonth.value - 1, 1)
  const startWeekday = first.getDay()
  const daysInMonth = new Date(viewYear.value, viewMonth.value, 0).getDate()
  const prevMonthDays = new Date(viewYear.value, viewMonth.value - 1, 0).getDate()
  for (let i = 0; i < startWeekday; i++) {
    const day = prevMonthDays - startWeekday + i + 1
    const prev = new Date(viewYear.value, viewMonth.value - 2, day)
    baseCells.push({ iso: toIsoDate(prev) })
  }
  for (let d = 1; d <= daysInMonth; d++) {
    const cur = new Date(viewYear.value, viewMonth.value - 1, d)
    baseCells.push({ iso: toIsoDate(cur) })
  }
  while (baseCells.length % 7 !== 0) {
    const last = baseCells[baseCells.length - 1]
    const [y, m, da] = last.iso.split('-').map(Number)
    const next = new Date(y, m - 1, da + 1)
    baseCells.push({ iso: toIsoDate(next) })
  }
  const { from, to } = gridRangeFromCells(baseCells)
  try {
    const res = await api.get(`/workspace/${workspaceId.value}/agendamentos/contagem`, {
      params: { from, to, _t: Date.now() }
    })
    mesContagens.value = res.data && typeof res.data === 'object' ? res.data : {}
  } catch (e) {
    console.warn('Erro ao carregar contagem do mês na agenda:', e)
    mesContagens.value = {}
  }
}


const mesAnterior = () => {

  if (viewMonth.value === 1) {

    viewMonth.value = 12

    viewYear.value -= 1

  } else {

    viewMonth.value -= 1

  }

}



const mesProximo = () => {

  if (viewMonth.value === 12) {

    viewMonth.value = 1

    viewYear.value += 1

  } else {

    viewMonth.value += 1

  }

}



const irParaHoje = () => {

  const hoje = new Date()

  viewYear.value = hoje.getFullYear()

  viewMonth.value = hoje.getMonth() + 1

  selecionar(toIsoDate(hoje))

}



const selecionar = (iso) => {

  selectedIso.value = iso

  const [y, m] = iso.split('-').map(Number)

  viewYear.value = y

  viewMonth.value = m

  carregarDia()

}



const carregarDia = async () => {

  loading.value = true

  erro.value = ''

  try {

    const res = await api.get(`/workspace/${workspaceId.value}/agendamentos`, {

      params: { date: selectedIso.value, _t: Date.now() }

    })

    itens.value = Array.isArray(res.data) ? res.data : []

  } catch (e) {

    erro.value = e.response?.data?.error || e.message || t('workspaceAgenda.errors.load')

    itens.value = []

  } finally {

    loading.value = false

  }

}



const abrir = async (it) => {

  try {

    if (it.tipo === 'CLIENTE') {
      router.push({
        name: 'WorkspaceClienteDetail',
        params: { id: workspaceId.value, clienteId: it.refId },
        query: { from: 'agenda' }
      })
      return
    }

    if (it.tipo === 'LEAD') {

      const r = await api.get(`/leads/${it.refId}`)

      selectedLead.value = r.data

      showLead.value = true

    } else {

      const r = await api.get(`/tasks/${it.refId}`)

      selectedTask.value = r.data

      showTask.value = true

    }

  } catch (e) {

    erro.value = t('workspaceAgenda.errors.openItem')

  }

}

const onLeadPatch = () => {

  showLead.value = false

  carregarDia()

  carregarContagensMes()

}



const onTaskPatch = () => {

  showTask.value = false

  carregarDia()

  carregarContagensMes()

}



onMounted(async () => {

  await workspaceStore.loadWorkspace(workspaceId.value)

  await Promise.all([carregarDia(), carregarContagensMes()])

})



watch([viewYear, viewMonth], () => {
  carregarContagensMes()
})

watch(workspaceId, async () => {

  await workspaceStore.loadWorkspace(workspaceId.value)

  await Promise.all([carregarDia(), carregarContagensMes()])

})

</script>



<style scoped>

.agenda-page {

  min-height: 100vh;

  background: var(--bg-primary);

  color: var(--text-primary);

}



.modern-header {

  width: 100%;

  box-sizing: border-box;

  background: linear-gradient(135deg, var(--bg-secondary) 0%, var(--bg-tertiary) 100%);

  border-bottom: 1px solid var(--border-primary);

  padding: 24px 0;

}



.header-container {

  width: 100%;

  padding: 0 24px;

  box-sizing: border-box;

  display: flex;

  flex-direction: column;

  gap: 20px;

}



.breadcrumb-section {

  display: flex;

  align-items: center;

}



.breadcrumb {

  display: flex;

  align-items: center;

  gap: 8px;

  font-size: 14px;

  flex-wrap: wrap;

}



.breadcrumb-item {

  display: flex;

  align-items: center;

  gap: 6px;

  padding: 6px 12px;

  background: transparent;

  border: none;

  border-radius: 4px;

  color: var(--text-secondary);

  cursor: pointer;

  transition: all 0.2s ease;

  font-size: 14px;

}



.breadcrumb-item:hover {

  background: var(--bg-hover);

  color: var(--text-primary);

}



.breadcrumb-separator {

  color: var(--text-muted);

  margin: 0 4px;

}



.breadcrumb-current {

  color: var(--text-primary);

  font-weight: 600;

}



.title-section {

  display: flex;

  justify-content: space-between;

  align-items: center;

  flex-wrap: wrap;

  gap: 16px;

}



.title-content {

  display: flex;

  align-items: center;

  gap: 16px;

}



.title-icon {

  display: flex;

  align-items: center;

  justify-content: center;

  width: 48px;

  height: 48px;

  border-radius: 4px;

  color: white;

  box-shadow: 0 4px 12px rgba(245, 158, 11, 0.35);

}



.title-icon--agenda {

  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);

}



.title-text {

  display: flex;

  flex-direction: column;

  gap: 4px;

}



.main-title {

  font-size: 28px;

  font-weight: 700;

  color: var(--text-primary);

  margin: 0;

}



.subtitle {

  font-size: 16px;

  color: var(--text-secondary);

  margin: 0;

}



.workspace-badge {

  display: flex;

  align-items: center;

  gap: 8px;

  padding: 8px 16px;

  border-radius: 4px;

  font-size: 14px;

  font-weight: 600;

}



.workspace-badge.type-crm {

  background: linear-gradient(135deg, #10b981 0%, #059669 100%);

  color: white;

}



.workspace-badge.type-tarefas {

  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%);

  color: white;

}



.badge-icon {

  display: flex;

  align-items: center;

}



.badge-text {

  font-weight: 600;

}



.actions-section {

  display: flex;

  gap: 12px;

  align-items: center;

  justify-content: space-between;

  flex-wrap: wrap;

  width: 100%;

}



.actions-left,

.actions-right {

  display: flex;

  align-items: center;

  gap: 12px;

  flex-wrap: wrap;

}



.actions-right {

  margin-left: auto;

}



.month-nav {

  display: flex;

  align-items: center;

  gap: 4px;

  padding: 4px;

  border-radius: 4px;

  border: 1px solid var(--border-primary);

  background: var(--bg-secondary);

}



.month-nav-btn {

  display: flex;

  align-items: center;

  justify-content: center;

  width: 36px;

  height: 36px;

  border: none;

  border-radius: 4px;

  background: transparent;

  color: var(--text-primary);

  cursor: pointer;

  transition: background 0.15s ease, color 0.15s ease;

}



.month-nav-btn:hover {

  background: rgba(245, 158, 11, 0.12);

  color: #d97706;

}



.month-nav-label {

  min-width: 140px;

  text-align: center;

  text-transform: capitalize;

  font-size: 14px;

  font-weight: 600;

  color: var(--text-primary);

  padding: 0 8px;

}



.action-button {

  display: flex;

  align-items: center;

  gap: 8px;

  padding: 10px 16px;

  border: none;

  border-radius: 4px;

  font-size: 14px;

  font-weight: 600;

  cursor: pointer;

  transition: all 0.2s ease;

}



.action-button.primary {

  background: linear-gradient(135deg, var(--accent-primary) 0%, #7c3aed 100%);

  color: white;

  box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);

}



.action-button.primary:hover {

  transform: translateY(-1px);

  box-shadow: 0 4px 12px rgba(99, 102, 241, 0.4);

}



.action-button.secondary {

  background: var(--bg-secondary);

  color: var(--text-primary);

  border: 1px solid var(--border-primary);

}



.action-button.secondary:hover {

  background: var(--bg-tertiary);

  transform: translateY(-1px);

}



.page-content {

  width: 100%;

  padding: 24px;

  box-sizing: border-box;

}



.layout {

  display: grid;

  grid-template-columns: minmax(280px, 1fr) minmax(320px, 1.1fr);

  gap: 16px;

}

@media (max-width: 900px) {

  .layout {

    grid-template-columns: 1fr;

  }

  .title-section {

    flex-direction: column;

    align-items: flex-start;

  }

  .actions-section {

    flex-direction: column;

    align-items: stretch;

  }

  .actions-right {

    margin-left: 0;

    justify-content: flex-end;

  }

}

.card {

  background: var(--bg-secondary);

  border: 1px solid var(--border-primary);

  border-radius: 4px;

  padding: 16px;

}

.weekdays {

  display: grid;

  grid-template-columns: repeat(7, 1fr);

  text-align: center;

  font-size: 12px;

  color: var(--text-secondary);

  margin-bottom: 8px;

}

.days {

  display: grid;

  grid-template-columns: repeat(7, 1fr);

  gap: 4px;

}

.day {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  min-height: 44px;
  border-radius: 4px;
  border: 1px solid transparent;
  padding: 8px 4px;
  cursor: pointer;
  background: var(--bg-primary);
  color: var(--text-primary);
  transition: background 0.15s ease, border-color 0.15s ease;
}
.day-num {
  line-height: 1.2;
}
.day-badge {
  position: absolute;
  top: 4px;
  right: 4px;
  min-width: 18px;
  height: 18px;
  padding: 0 4px;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-shadow: 0 1px 3px rgba(239, 68, 68, 0.4);
}
.day--has:not(.selected) {
  background: rgba(239, 68, 68, 0.1);
  border-color: rgba(239, 68, 68, 0.25);
  color: #dc2626;
  font-weight: 600;
}
.day--has:not(.selected):hover {
  background: rgba(239, 68, 68, 0.16);
}
.day.selected.day--has {
  background: rgba(99, 102, 241, 0.2);
  border-color: #6366f1;
  color: var(--text-primary);
}
.day.muted.day--has {
  opacity: 0.65;
}
.day.muted {

  opacity: 0.45;

}

.day.selected {

  border-color: #6366f1;

  background: rgba(99, 102, 241, 0.15);

  font-weight: 700;

}

.day.hoje {

  outline: 1px dashed #22c55e;

}

.lista {
  display: flex;
  flex-direction: column;
  min-height: 280px;
}

.lista-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--border-primary);
}

.lista-title {
  margin: 0;
  font-size: 17px;
  font-weight: 700;
  line-height: 1.35;
  text-transform: capitalize;
  color: var(--text-primary);
}

.lista-count {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  padding: 5px 10px;
  border-radius: 999px;
  background: rgba(99, 102, 241, 0.12);
  color: #6366f1;
  border: 1px solid rgba(99, 102, 241, 0.2);
}

.lista-state {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 24px 8px;
  color: var(--text-secondary);
  font-size: 14px;
}

.lista-state-spinner {
  width: 22px;
  height: 22px;
  border: 2px solid var(--border-primary);
  border-top-color: #6366f1;
  border-radius: 50%;
  animation: agenda-spin 0.7s linear infinite;
}

@keyframes agenda-spin {
  to { transform: rotate(360deg); }
}

.itens {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.agenda-item {
  position: relative;
  display: grid;
  grid-template-columns: auto 4px 1fr auto;
  align-items: stretch;
  gap: 0;
  padding: 0;
  border-radius: 4px;
  border: 1px solid var(--border-primary);
  background: var(--bg-primary);
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease;
}

.agenda-item:hover {
  border-color: rgba(99, 102, 241, 0.45);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
  transform: translateY(-1px);
}

.agenda-item:hover .agenda-item-arrow {
  opacity: 1;
  transform: translateX(2px);
}

.agenda-item--task {
  --agenda-accent: #3b82f6;
  --agenda-accent-soft: rgba(59, 130, 246, 0.12);
}

.agenda-item--lead {
  --agenda-accent: #10b981;
  --agenda-accent-soft: rgba(16, 185, 129, 0.12);
}

.agenda-item--agendado {
  --agenda-accent: #3b82f6;
  --agenda-accent-soft: rgba(59, 130, 246, 0.14);
}

.agenda-item--realizado {
  --agenda-accent: #10b981;
  --agenda-accent-soft: rgba(16, 185, 129, 0.14);
}

.agenda-item--remarcado {
  --agenda-accent: #f59e0b;
  --agenda-accent-soft: rgba(245, 158, 11, 0.16);
}

.agenda-item--cancelado {
  --agenda-accent: #ef4444;
  --agenda-accent-soft: rgba(239, 68, 68, 0.12);
  opacity: 0.92;
}

.agenda-item--cancelado .agenda-item-title {
  text-decoration: line-through;
  opacity: 0.75;
}

.agenda-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.625rem 1rem;
  margin-bottom: 14px;
  padding: 10px 12px;
  border-radius: 4px;
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
}

.agenda-legend__item {
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-secondary);
}

.agenda-legend__dot {
  width: 10px;
  height: 10px;
  border-radius: 2px;
  flex-shrink: 0;
}

.agenda-legend__dot--agendado { background: #3b82f6; }
.agenda-legend__dot--realizado { background: #10b981; }
.agenda-legend__dot--remarcado { background: #f59e0b; }
.agenda-legend__dot--cancelado { background: #ef4444; }

.agenda-item-status {
  font-size: 0.6875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  border: 1px solid transparent;
}

.agenda-item-status--agendado {
  color: #2563eb;
  background: rgba(59, 130, 246, 0.12);
  border-color: rgba(59, 130, 246, 0.25);
}

.agenda-item-status--realizado {
  color: #059669;
  background: rgba(16, 185, 129, 0.12);
  border-color: rgba(16, 185, 129, 0.25);
}

.agenda-item-status--remarcado {
  color: #d97706;
  background: rgba(245, 158, 11, 0.14);
  border-color: rgba(245, 158, 11, 0.3);
}

.agenda-item-status--cancelado {
  color: #dc2626;
  background: rgba(239, 68, 68, 0.1);
  border-color: rgba(239, 68, 68, 0.25);
}

.agenda-item-time {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 72px;
  padding: 14px 12px;
  background: var(--agenda-accent-soft);
  border-right: 1px solid var(--border-primary);
}

.agenda-item-hour {
  font-size: 15px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.02em;
  color: var(--agenda-accent);
}

.agenda-item-accent {
  width: 4px;
  background: linear-gradient(180deg, var(--agenda-accent) 0%, transparent 100%);
}

.agenda-item-body {
  min-width: 0;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.agenda-item-top {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

.agenda-item-type {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--agenda-accent);
}

.agenda-item-type-ico {
  width: 14px;
  height: 14px;
}

.agenda-item-col {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  background: var(--bg-secondary);
  color: var(--text-secondary);
  border: 1px solid var(--border-primary);
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.agenda-item-title {
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  line-height: 1.35;
  color: var(--text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.agenda-item-motivo {
  display: flex;
  align-items: flex-start;
  gap: 6px;
  margin: 0;
  font-size: 12px;
  line-height: 1.4;
  color: var(--text-secondary);
}

.agenda-item-motivo-ico {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
  margin-top: 1px;
  opacity: 0.75;
}

.agenda-item-arrow {
  width: 18px;
  height: 18px;
  align-self: center;
  margin-right: 12px;
  color: var(--text-secondary);
  opacity: 0.35;
  transition: opacity 0.2s ease, transform 0.2s ease;
  flex-shrink: 0;
}

.agenda-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  border-radius: 4px;
  border: 1px dashed var(--border-primary);
  background: var(--bg-primary);
}

.agenda-empty-icon {
  width: 52px;
  height: 52px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(245, 158, 11, 0.12);
  color: #d97706;
  margin-bottom: 12px;
}

.agenda-empty-icon svg {
  width: 28px;
  height: 28px;
}

.agenda-empty-title {
  margin: 0 0 4px;
  font-size: 15px;
  font-weight: 600;
  color: var(--text-primary);
}

.agenda-empty-text {
  margin: 0;
  font-size: 13px;
  color: var(--text-secondary);
}

.muted {

  color: var(--text-secondary);

}

.erro {

  color: #b91c1c;

}

</style>

